export class GeneralConfiguration {
    generalConfigurationId: string;
    generalConfigurationTypeId: string;
    key: string;
    value: string;
}